export const moduleName = 'billing';

export default {
  EDIT_BILLING_FORM_FAILURE: `${moduleName}/EDIT_BILLING_FORM_FAILURE`,
  EDIT_BILLING_FORM_REQUEST: `${moduleName}/EDIT_BILLING_FORM_REQUEST`,
  EDIT_BILLING_FORM_SUCCESS: `${moduleName}/EDIT_BILLING_FORM_SUCCESS`,
};
